/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const profileStatusHistorySchema = z.object({
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  previousProfileStatus: z.string().nullish(),
  profileStatus: z.string().nullish(),
  profileStatusLastUpdatedBy: z.string().uuid().nullish(),
  profileStatusUpdatedAt: z.string().datetime().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type ProfileStatusHistory = z.infer<typeof profileStatusHistorySchema>;
